/** A key which uniquely identifies a given navigator item. */
enum NavigatorItemId {
  Screening,
  Scheduling,
  Confirmation
}

export default NavigatorItemId;
